var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.027,
    height: 47.671,
    viewBox: "0 0 48.027 47.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M0,0H48.027V-47.671H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(0 47.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M4.028-42.449H17.857v1.24H4.028Z",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M4.028-39.969H17.857v1.24H4.028Z",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M10.314-33.763H31.685v1.24H10.314Z",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M4.028-31.282h5.03v-4.966H4.028ZM5.284-35H7.8v2.481H5.289Z",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M4.028-23.835h5.03V-28.8H4.028Zm1.256-3.721H7.8v2.48H5.289Z",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M4.028-16.389h5.03v-4.966H4.028ZM5.284-20.11H7.8v2.481H5.289Z",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M4.028-12.668H31.681v1.24H4.028Z",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M4.028-8.942h17.6V-7.7H4.028Z",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M10.314-18.87h11.98v1.24H10.314Z",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(31.685 -18.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M0,0H-.673L-1.93,1.24H0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(29.665 -26.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M0,0H-19.351V1.24H-1.256Z",
    fill: "#8cc63f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(0.5 -47.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M0,0V46.67H34.712V23.905l-1.238,1.232V45.444H1.238V1.228H33.474V16.451l1.238-1.227V0Z",
    fill: "#8cc63f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    transform: "translate(33.974 -1.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M0,0H-32.235V-44.216H0v15.224L1.239-30.22V-45.444H-33.474V1.227H1.239V-21.539L0-20.307Z",
    fill: "none",
    stroke: "#8cc63f",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(47.291 -39.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M0,0A2.536,2.536,0,0,0-1.777-.725,2.536,2.536,0,0,0-3.554,0L-23.11,19.307l-1.256,1.241v3.508h3.553l1.257-1.24,7.112-7.018L0,3.513A2.47,2.47,0,0,0,.736,1.757,2.472,2.472,0,0,0,0,0ZM-21.333,22.816H-23.11V21.062l8-7.9,1.777,1.754ZM-.888,2.632-12.444,14.044l-1.777-1.754L-2.666.877A1.268,1.268,0,0,1-1.452.556a1.25,1.25,0,0,1,.889.877,1.23,1.23,0,0,1-.326,1.2Z",
    fill: "#662d91"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteEdit);
export default __webpack_public_path__ + "static/media/note-edit.00f5cc4ac516ff25d2a43965da3a0838.svg";
export { ForwardRef as ReactComponent };